import { render, staticRenderFns } from "./NowItem.vue?vue&type=template&id=36066e67"
import script from "./NowItem.vue?vue&type=script&lang=js"
export * from "./NowItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36066e67')) {
      api.createRecord('36066e67', component.options)
    } else {
      api.reload('36066e67', component.options)
    }
    module.hot.accept("./NowItem.vue?vue&type=template&id=36066e67", function () {
      api.rerender('36066e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/NowItem.vue"
export default component.exports